export default __webpack_public_path__ + "static/media/small-rupee.4a5236af.svg";